export const rootElementId = 'access-management-upsell-container';

export const accessManagementUpselTranslationConfig = {
  common: ['CommonUI.Controls', 'CommonUI.Features', 'Amp.Upsell'],
  feature: 'Verification.Identity'
};

export const emailUpsellTranslationConfig = {
  common: ['CommonUI.Controls'],
  feature: 'Feature.VerificationUpsell'
};

export const parentalRequestTranslationConfig = {
  common: ['CommonUI.Controls', 'CommonUI.Features', 'Amp.Upsell'],
  feature: 'Feature.Parents'
};
